import React, { Component } from 'react'
import AnimakitExpander from 'animakit-expander';

import './support-styles.css'


export default class FAQitem extends Component {
  constructor(props) {
    super(props);
    this.state = { toggle: false };
    this.onFAQClick = this.onFAQClick.bind(this);

  }
  onFAQClick(e) {
    this.setState(prevState => ({
      toggle: !prevState.toggle
    }))
  }

  render() {
    return (
      <div>
        <h3 className='faqItem' onClick={this.onFAQClick}>{this.props.q}</h3>
        <AnimakitExpander expanded={this.state.toggle}>
          <p>{this.props.a}</p>
        </AnimakitExpander>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// ./src/Views/Support/FAQItem.js